import mr from '../index';
import message from '../../message';
import { send, sendRe } from '../send';
import { PermeatorPlatform } from '../PermeatorExt';
import fromSMP from '../fromSMP';

const P_NAME = 'srp-main';

let sourceWindow = null;

const p: PermeatorPlatform = {
    push(url: string, payload?: any, option?: any) {
        send('push', {
            link: url,
            payload,
            option
        });
    },
    replace(url: string, payload?: any, option?: any) {
        send('replace', {
            link: url,
            payload,
            option
        });
    },
    open(url: string, payload?: any, option?: any) {
        let targetWindowName = null;
        send('open', {
            link: url,
            payload,
            option
        }).then(({ $targetWindowName }) => {
            targetWindowName = $targetWindowName;
        });
        return {
            onClose(callback) {
                message.on('openTargetClosed', ({ $sourceWindowName }) => {
                    if ($sourceWindowName === targetWindowName) {
                        callback();
                    }
                });
            }
        };
    },
    close(option: any = {}) {
        if (option.noticeSourceWindow) {
            send('broadcast', {
                $broadcast: 'openTargetClosed',
                $broadcastTarget: sourceWindow,
                $broadcastPayload: {}
            });
        }
        send('close');
    },

    onClose(callback) {
        send('preventClose');

        const listener = message.on('close', () => {
            callback(() => {
                listener.off();
                mr.close();
            });
        });

        return {
            off() {
                listener.off();
                send('unPreventClose');
            }
        }
    },

    title(title:string) {
        send('title', {
            value: title
        });
    },

    activeMenu(code:string) {
        send('activeMenu', {
            value: code
        });
    },

    async getSelectedShop() {
        return sendRe('getSelectedShop');
    },

    async getAuthZ() {
        return sendRe('getAuthZ');
    },

    async $getOpenPayload() {
        return sendRe('getOpenPayload')
            .then((payload: any = {}) => {
                sourceWindow = payload.$sourceWindowName;
                return payload;
            })
            .catch(() => undefined);
    }
};

export const envTest = async () => {
    return Promise.resolve(fromSMP((platformType) => {
        /** 通过同步方法 */
        if (platformType === P_NAME) {
            /** 异步再次验证 */
            sendRe('PR:platformConnect', {
                title: document.title
            }).then((res: any) => {
                if (res.platformType !== P_NAME) {
                    console.error('SMP:MR 平台接待对接失败, 平台类型不匹配', res);
                }
            }).catch((err) => {
                console.error(err);
            });
            return true;
        } else {
            return false;
        }
    }));
};

export default p;